module.exports = __webpack_public_path__ + "static/media/icon-radiopublic.cb2b0eb8.svg";